import { FEATURE_FLAGS } from '../constant/featureFlags';
import {
  HOME_VISIBLE_TASKS,
  TaskTabSegment,
  taskTabPath,
} from '../pages/v3/Tasks/taskTabs';
import { IfFeatureEnabledMSR3 } from './IfFeatureEnabledMSR3';
import { SnapshotViewAll } from './SnapshotViewAll';

interface TaskSnapshotViewAllProps {
  segment: TaskTabSegment;
  totalTasks: number;
  workspaceId?: string;
}

/**
 * "View All" link for a Home task snapshot, shown when the snapshot holds more
 * tasks than Home displays. One shared flag gates every snapshot so they cannot
 * drift apart between environments.
 */
export const TaskSnapshotViewAll = ({
  segment,
  totalTasks,
  workspaceId,
}: TaskSnapshotViewAllProps) => {
  if (!workspaceId) return null;

  return (
    <IfFeatureEnabledMSR3 name={FEATURE_FLAGS.MSR3_TASKS_VIEW_ALL}>
      <SnapshotViewAll
        to={taskTabPath(workspaceId, segment)}
        total={totalTasks}
        visibleCount={HOME_VISIBLE_TASKS}
      />
    </IfFeatureEnabledMSR3>
  );
};
